import { render, staticRenderFns } from "./BlogLocaleForm.vue?vue&type=template&id=3c13b0d8&scoped=true"
import script from "./BlogLocaleForm.vue?vue&type=script&lang=js"
export * from "./BlogLocaleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13b0d8",
  null
  
)

export default component.exports